const forgotPasswordStyles = (theme) => {
  return {
    gridOccupy: {
      width: '100%',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      paddingTop: theme.spacing(1),
    },
    inputStyles: {
      height: 25,
      minWidth: 320,
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(4.5),
      marginBottom: theme.spacing(2.5),
      flex: 1,
      paddingLeft: 5,
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
      },
      '& .MuiFormHelperText-root': {
        marginTop: 0,
      },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0000003b',
      },
    },

    button: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      color: '#fff', //D1373F
      backgroundColor: '#008000',
      borderColor: '#008000',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },

    button1: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      color: '#fff', //D1373F
      backgroundColor: '#90103B',
      borderColor: '#90103B',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        backgroundColor: '#90103B',
        borderColor: '#00acc1',
      },
    },
    btnContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: theme.spacing(2),
      justifyContent: 'center',
      alignItems: 'center',
    },
    popOverContainer: {
      alignSelf: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      maxWidth: 320,
    },
    btnStyleJoin: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0.8),
      paddingRight: theme.spacing(0.8),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      borderColor: '#008000',
      backgroundColor: '#008000',
      // minWidth: theme.spacing(14),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    arrowIcon: {
      padding: 0,
      marginRight: 0,
      height: 15,
      width: 15,
    },
    horizontalLine: {
      borderBottom: '1px solid gainsboro',
      height: 1,
      width: '94%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  };
};

export default forgotPasswordStyles;
